module.exports = __webpack_public_path__ + "static/media/kredyt_35.50551f85.png";